<app-layout>
  <app-layout-title>
    <app-go-back-button (click)="goBack()">
      {{ 'ADMIN.user_statuses' | translate:{ name: (user | async).fullName, project: (project | async).name } }}
    </app-go-back-button>
  </app-layout-title>
  <app-layout-actions></app-layout-actions>
  <app-layout-content>
    <app-hint>
      <span>{{ 'ADMIN.all_statuses_hint' | translate }}</span>
    </app-hint>

    <div class="statuses-list">
      @for (status of assignedStatuses; track status) {
        <mat-checkbox
          [(ngModel)]="status.isAssigned">{{ status.name }}
        </mat-checkbox>
      }
    </div>

    <app-button-group>
      <app-yes-no (action)="assignStatuses()" (cancel)="goBack()" [actionName]="'ADMIN.assign' | translate"></app-yes-no>
    </app-button-group>
  </app-layout-content>
</app-layout>
